SP.MainNavigation = Garnish.Base.extend({
    $nav: null,

    $parentLinks: null,

    init(nav) {
        let self = this
        this.$nav = nav

        this.$parentLinks = this.$nav.querySelectorAll('.hasChild')

        Array.prototype.forEach.call(this.$parentLinks, function (el, i) {
            // el.addEventListener('mouseenter', function (event) {
            //     self.resetAria()
            //     let target = event.target
            //     let hasPopup = target.getAttribute('aria-haspopup') === 'true'
            //     if (hasPopup) {
            //         self.openAria(event.target)
            //     }
            // })
            //
            // el.addEventListener('mouseleave', function (event) {
            //     self.resetAria()
            // })


            el.addEventListener('keyup', function (event) {
                let key = event.keyCode
                console.log('key: ', key)

                if (key === 13) {
                    self.resetAria()

                    el.classList.add('aria-active')
                    el.setAttribute('aria-expanded', 'true')

                    // if (el.classList.contains('aria-active')) {
                    //     el.classList.remove('aria-active')
                    //     el.setAttribute('aria-expanded', 'false')
                    // } else {
                    //     // self.resetAria()
                    //
                    //     el.classList.add('aria-active')
                    //     el.setAttribute('aria-expanded', 'true')
                    // }
                }

                if (key === 27) {
                    self.resetAria()
                }
            })
        })
    },


    resetAria() {
        Array.prototype.forEach.call(this.$parentLinks, function (el, i) {
            el.classList.remove('aria-active')
            el.setAttribute('aria-expanded', 'false')
        })
    },

    openAria(target) {
        console.log('target: ', target)
        target.setAttribute('aria-expanded', 'true')
    }
})

SP.MobileNavigation = Garnish.Base.extend({
    $menu: null,
    $menuWrapper: null,
    $menuBtn: null,

    isDesktop: true,

    init(el) {
        let self = this
        this.$menuWrapper = $(el)
        this.$menu = this.$menuWrapper.find('.main-nav')
        this.$menuBtn = $('#mobile-menu-trigger')

        this.createSubmenus()

        this.childLinks = this.$menuWrapper.find('li.hasChild > a')
        this.backBtns = this.$menuWrapper.find('li.back a')

        this.addListener(this.$menuBtn, 'click', this.toggleMenuOpen)

        $.each(this.childLinks, $.proxy(function (index, el) {
            this.addListener(el, 'click', el, this.showSubmenu)
        }, this))

        $.each(this.backBtns, $.proxy(function (index, el) {
            this.addListener(el, 'click', el, this.hideSubmenu)
        }, this))
    },

    showSubmenu(ev) {
        if (!this.isDesktop) {
            ev.preventDefault()

            this.$menuWrapper.scrollTop(0)
            $(ev.data).parent().addClass('active').siblings().removeClass('active')

            // Adding height to menus for mobile scrolling fixes
            let submenu = $(ev.data).parent().find('> ul.submenu')
            let submenuHeight = submenu.height() + 100
            submenu.css('height', submenuHeight + 'px')
        }
    },

    hideSubmenu(ev) {
        ev.preventDefault()
        $(ev.data).closest('ul.submenu').parent().removeClass('active')

        $(ev.data).closest('ul.submenu').removeAttr('style')
    },

    toggleMenuOpen() {
        window.UI.updateMobileNavigation('nav')
    },

    createSubmenus() {
        this.$menuWrapper.find('ul.submenu').each(function () {
            let dis = $(this)
            let disPar = dis.closest('li')
            let disfA = disPar.find('> a')
            let disBack = $('<li/>', {
                'class': 'back',
                'html': '<a href="#"><svg width="15" height="26" viewBox="0 0 15 26" xmlns="http://www.w3.org/2000/svg"><path d="M-.06 12.646L12.645-.06l1.415 1.415L2.769 12.646 14.06 23.94l-1.415 1.415z" fill="#000" fill-rule="nonzero"/></svg>\n' + disfA.text() + '</a>'
            })

            disPar.addClass('hasChild')
            disBack.prependTo(dis)
        })
    },

    enableDesktop() {
        this.isDesktop = true
    },

    disableDesktop() {
        this.isDesktop = false
    }
})
